import { BrandHomeLink } from '@components/BrandHomeLink'
import { OokeyLogo } from '@components/OokeyLogo'

/**
 * 認証フォーム上部に置く OoKey ブランド (logo)。
 *
 * split-screen の art panel (.auth-art) は mobile で非表示になるため、
 * 各 auth ページの `.auth-form-inner` 先頭・タイトル `<h1>` の直前に配置して、
 * ログイン前の全フォーム画面でブランドを示す。
 * ロゴクリックで root `/` (トップページ) に戻る。
 */
export const AuthBrand = (): JSX.Element => (
  <BrandHomeLink className="auth-brand" ariaLabel="OoKey">
    <OokeyLogo size={30} />
  </BrandHomeLink>
)
